import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { TranslateModule } from '@ngx-translate/core'

import { DateFieldModule } from '../date-selector'
import { FormErrorModule } from '../form-error'
import { PriorAuthorizationFormModule } from '../prior-authorization-form'
import { ServiceReviewSubmissionDialogComponent, ServiceReviewSubmissionPreviewComponent } from './components'

@NgModule({
  imports: [
    CommonModule,
    DateFieldModule,
    FlexLayoutModule,
    FormErrorModule,
    MatButtonModule,
    MatDialogModule,
    PriorAuthorizationFormModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  declarations: [
    ServiceReviewSubmissionDialogComponent,
    ServiceReviewSubmissionPreviewComponent,
  ],
  exports: [
    ServiceReviewSubmissionDialogComponent,
  ],
})
export class ServiceReviewSubmissionModule {}
